<template>
  <div class="portrait">
    <div class="portrait-container">
      <!-- <div class="portrait-overlay"></div> -->
      <CustomIcon :name="image" class="portrait-image" />
      <div class="portrait-header">
        <p class="portrait-header-title">{{ title }}</p>
        <p class="portrait-header-description">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "portrait-image",
  props: {
    image: String,
    title: String,
    description: String,
  },
  components: { CustomIcon },
  computed: {},
};
</script>
